// extracted by mini-css-extract-plugin
export default {"container":"style_container__08hIH","title_row":"style_title_row__dzK+m","text_content":"style_text_content__a56z1"};